export const revenueTabColors: Array<string> = [
	'#12afcb',
	'#8dc63f',
	'#bd8cbf',
	'#476173',
	'#22baa0',
	'#f7941d',
	'#ffcc33',
	'#69c0eb',
	'#7971ae',
	'#f26d7d'
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/services/graph/graph.model.ts